import ExperienceLoop from '../../assets/images/howSubhead/experience_loop.gif'
import Innovation from '../../assets/images/howSubhead/innovation.gif'
import Prioritization from '../../assets/images/howSubhead/prioritization.gif'
import StudioX from '../../assets/images/howSubhead/studio_x.gif'

export const HowSubheadMockData = [
  {
    img: ExperienceLoop,
    title: 'Experience Loop',
    description: 'A six-phase process to bring amazing experiences to life.',
    link: process.env.REACT_APP_EXPERIENCE_LOOP_LINK ?? '',
    icon: 'arrow',
    background: '#CB4865',
    event_type: 'pg_act_ourwork_whw_viewexperienceloop',
    video_src: '',
  },
  {
    img: Innovation,
    title: 'Innovation',
    description: 'Discover what the market is thirsting for, and then make it happen.',
    link: process.env.REACT_APP_INNOVATION_LINK ?? '',
    icon: 'arrow',
    background: '#008C13',
    event_type: 'pg_act_ourwork_whw_viewinnovation',
    video_src: '',
  },
  {
    img: Prioritization,
    title: 'Prioritization',
    description: 'Focusing our strengths and resources on the projects that further our goals.',
    link: process.env.REACT_APP_PRIORITIZATION_LINK ?? '',
    icon: 'arrow',
    background: '#FC4D0F',
    event_type: 'pg_act_ourwork_whw_viewprioritization',
    video_src: '',
  },
  {
    img: StudioX,
    title: 'Studio X',
    description:
      'Learn more about the core and modern capabilities, our brief types and playbooks, and our best work around the world.',
    link: '',
    icon: '',
    background: '#AE46D5',
    event_type: 'pg_act_ourwork_whw_viewstudioxplaybook',
    coming_soon: true,
    coming_soon_position: 'left',
    video_src: '',
  },
  // {
  //   img: MatchAndThrive,
  //   title: 'Match & Thrive',
  //   description:
  //     'A holistic support system for growth, matching your skills & interests to deliver top prioritized projects.',
  //   link: '',
  //   icon: 'arrow',
  //   background: '#0E8480',
  //   event_type: 'pg_act_ourwork_whw_viewm&t',
  //   coming_soon: false,
  //   coming_soon_position: 'right',
  //   video_src:
  //     'https://facade-api-tccc-prod-coke.playground.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/a0753290-b167-463e-a4de-0e69508023b6/public-download',
  // },
]
